import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { useInputHeightContext } from "../../contexts";
import { resetReplyMessageId } from "../../actions";
import { selectAuthorList, selectReplyMessage } from "../../selectors";

export const useReplyMessage = () => {
  const dispatch = useAppDispatch();
  const { handleChangeReplyMessageHeight, setFocusToInput } =
    useInputHeightContext();

  const replyMessage = useAppSelector(selectReplyMessage);

  const replyMessageId = replyMessage ? Number(replyMessage.id) : null;

  const authorList = useAppSelector(selectAuthorList);
  const replyAuthor = replyMessage ? authorList[replyMessage?.authorId] : null;

  const handleClearReplyMessage = () => dispatch(resetReplyMessageId());

  useEffect(() => {
    handleChangeReplyMessageHeight(!!replyMessage?.id);
    setFocusToInput();
  }, [replyMessage]);

  return { replyAuthor, replyMessage, replyMessageId, handleClearReplyMessage };
};
